// src/plugins/autoTranslate.js
import { GoogleTranslateService } from "@/services/googleTranslate";

export default {
  install(app, opts = {}) {
    const gt = new GoogleTranslateService(opts);

    app.config.globalProperties.$gt = gt;
    app.provide("gt", gt);

    // Skip remote script load when an env flag asks for it (e.g. local dev with
    // AdBlock active). Production behaviour unchanged.
    if (process.env.VUE_APP_DISABLE_GT === "true") {
      return;
    }

    gt.load()
      .then(() => {
        gt.startObserver();
        gt.setLanguage(gt.getLanguage());
      })
      .catch(() => {
        // Translation widget failed to load (blocked / offline / CSP). Non-fatal.
      });
  },
};
